import styles from './Selectmenu.module.scss';
import images from 'assets/Images';
import { useState, useRef, useEffect, useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import Images from 'assets/Images';
import OverviewContext from 'store/overview-context';
export default function SelectMenu(props) {
	const [dropdownToggle, setDropdownToggle] = useState(false);
	const [dropdownAnimation, setdropdownAnimation] = useState(false);
	const [selectedOptions, setSelectedOptions] = useState([]);
	const [dropdownOptions, setDropdownOptions] = useState([]);
	const dropdownOptionsRef = useRef();
	const dropdownDisplayRef = useRef();
	const { value, onChange, menuOptions, disabled, infoContent, multiple, placeholder, label, mandatory } = props;

	const overviewContext = useContext(OverviewContext);

	// dropdown toggler and animation state handler
	const dropdownToggler = useCallback(
		e => {
			if (!disabled) {
				if (!e) {
					setdropdownAnimation(prevState => !prevState);
					setTimeout(() => {
						setDropdownToggle(prevState => !prevState);
					}, 100);
				} else {
					setDropdownToggle(prevState => !prevState);
					setTimeout(() => {
						setdropdownAnimation(prevState => !prevState);
					}, 100);
				}
			}
		},
		[disabled, setdropdownAnimation]
	);

	// outside click handle function
	const handleClickOutside = useCallback(
		event => {
			if (dropdownOptionsRef?.current && !dropdownOptionsRef?.current?.contains(event?.target) && !dropdownDisplayRef?.current?.contains(event?.target)) {
				dropdownToggle && dropdownToggler(false);
			}
		},
		[dropdownToggler, dropdownToggle]
	);

	// set menu options state
	useEffect(() => {
		setDropdownOptions(menuOptions);
	}, [menuOptions]);

	// two way binding
	useEffect(() => {
		value && setSelectedOptions(value);
	}, [value]);

	// outside click handler
	useEffect(() => {
		document.addEventListener('click', handleClickOutside, true);
		return () => {
			document.removeEventListener('click', handleClickOutside, true);
		};
	}, [dropdownToggle, handleClickOutside]);

	// dropdown select handler
	const selectHandler = e => {
		const options = multiple ? [...new Set([e, ...selectedOptions])] : [e];
		setSelectedOptions(options);
		!multiple && dropdownToggler(false);
		onChange(multiple ? options?.map(el => el?.key) : options?.[0]?.key);
	};

	// remove selected options
	const removeOptions = e => {
		const data = selectedOptions?.filter(el => el.key !== e?.key);
		setSelectedOptions(data);
		onChange(multiple ? data?.map(el => el?.key) : data?.[0]?.key);
	};

	// dropdown option list
	const menuContent =
		dropdownOptions?.length > 0 ? (
			dropdownOptions?.map((el, i) => (
				<li key={el?.value} onClick={() => selectHandler(el)}>
					{el?.value}
				</li>
			))
		) : (
			<span>No records found!</span>
		);

	// display content or placeholder on select
	const displayContent =
		selectedOptions?.length > 0 ? (
			<span>
				{selectedOptions[0]?.value} {selectedOptions?.length > 1 && `+${selectedOptions.length - 1}`}
			</span>
		) : (
			<span className={styles['container__dropdown--placeholder']}>{placeholder}</span>
		);

	const selectedContent = selectedOptions?.map(el => (
		<span className={styles['container__dropdown--selectedtab']} onClick={() => removeOptions(el)} key={el?.value}>
			{el?.value}
		</span>
	));

	// search functionality
	const searchValue = event => {
		const filteredData = menuOptions?.filter(items => items?.value?.toLowerCase()?.includes(event?.target?.value?.toLowerCase()));
		setDropdownOptions(filteredData);
	};

	const getLang = key => {
		return overviewContext?.langObj?.content?.[key] || '';
	};

	return (
		<>
			<div className={`${styles.container} ${disabled && styles['container--disabled']}`}>
				{label && (
					<label>
						{label} {mandatory && <sup>*</sup>}
						{infoContent && (
							<div className={styles['container__helpContainer']}>
								<div className={styles['container__help']}>
									<img src={Images.help} />
								</div>
								<div className={styles['container__helpContent']}>{infoContent}</div>
							</div>
						)}
					</label>
				)}
				<div ref={dropdownOptionsRef} className={styles.container__dropdown}>
					<div ref={dropdownDisplayRef} className={styles['container__dropdown--display']} onClick={() => dropdownToggler(!dropdownToggle)}>
						{displayContent}
					</div>
					<img className={styles['container__dropdown--icon']} src={images.downArrow} onClick={() => dropdownToggler(!dropdownToggle)} alt='arrow' />
					{dropdownToggle && (
						<ul className={`scroll-bar ${dropdownAnimation ? styles['container__dropdown--open'] : styles['container__dropdown--close']}`}>
							<li>
								<input placeholder={getLang('SEARCH')} onChange={searchValue} />
								<div className={styles['container__selected']}>{selectedContent}</div>
							</li>
							{menuContent}
						</ul>
					)}
				</div>
			</div>
		</>
	);
}

SelectMenu.propTypes = {
	value: PropTypes.any,
	onChange: PropTypes.any,
	menuOptions: PropTypes.any,
	disabled: PropTypes.bool,
	multiple: PropTypes.bool,
	placeholder: PropTypes.string,
	label: PropTypes.string,
	mandatory: PropTypes.bool
};

SelectMenu.defaultProps = {
	value: '',
	onChange: '',
	menuOptions: '',
	disabled: false,
	multiple: false,
	placeholder: '',
	label: '',
	mandatory: false
};
